// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"20abbabc","289":"6d8b7e3d","458":"768aee7d"}[chunkId] + ".chunk.js";
};